<template>
  <div class="dynamic">
    <div class="w">
      
      <div class="select_tabs"></div>
      <div class="left_list">
        
        <ul class="all_styles">
          <li
            class="style_each"
            v-for="(item, index) in dynamicList"
            :key="index"
            @click="xq(item.id)"
          >
            <div class="cur_links">
              <h2 class="cur_topic">
                <div class="check_titls">{{ item.title }}</div>
              </h2>
              <div class="all_intros">
                <span class="cur_time">{{ item.create_time   }}</span>
              </div>
              <div class="list_details" v-html="item.content"></div>
            </div>
          </li>
        </ul>
 
        <div class="pagination">
          <pagination
            class="pages"
            v-show="total > 0"
            :total="total"
            layout=" prev, pager, next "
            :page.sync="listQuery.page"
            :limit.sync="listQuery.limit"
            @pagination="getList"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ArticleList } from "../../../common/js/api";
import { formatDate } from "../../../common/js/times"; //时间
import Pagination from "@/common/Pagination";

export default {
  name: "DynamicNei",
  components: { Pagination },
  data() {
    return {
      dynamicList: [],
      total: 0, //总条目数
      listQuery: {
        limit: 5,
        page: 1,
      },
    };
  },
  filters: {
    formatDate(time) {
      time = time * 1000;
      let date = new Date(time);
      return formatDate(date, "yyyy-MM-dd");
    },
  },
  created() {
    this.getList();
  },
  methods: {
    // 获取列表
    getList() {
      ArticleList({
        page: this.listQuery.page,
        limits: this.listQuery.limit,
        
      })
        .then((res) => {
          this.dynamicList = res.data.data;
          this.total = res.data.total;
          for (var i = 0; i < this.dynamicList.length; i++) {
            this.dynamicList[i].content = this.dynamicList[i].content.replace(
              /<\/?(img)[^>]*>/gi,
              ""
            );
          }
        })
        .catch(() => {});
    },
    xq(id) {
      this.$router.push({
        path: "/Dynamicxq",
        query: {
          id: id,
        },
      });
    },
  },
  mounted() {},
};
</script>

<style scoped lang="less">
/* 科服云动态列表 */
.dynamic {
  background: url(../../../assets/img/kefuyun/dt.png);
  background-size: 100% 100%;
  width: 100%;
  padding-bottom: 100px;
}
/* 边框  */
.select_tabs {
  margin: 20px auto auto;
  height: 40px;
  background-color: rgba(56, 146, 235, 100);
  border-radius: 5px;
}
.left_list {
  font-size: 12px;
  background: #fff;
  border-radius: 4px;
  padding: 12px 50px 20px;
  min-height: 894px;
  margin-top: 135px;
}
.all_styles .style_each {
  border-bottom: 1px dashed #ddd;
  cursor: pointer;
}
.all_styles .style_each .cur_links {
  display: block;
  padding: 18px 0;
  color: #333;
}
.all_styles .style_each .cur_links .cur_topic .check_titls {
  font-size: 20px;
  color: #2a71d2;
}

.all_styles .style_each .cur_links .all_intros {
  margin-top: 20px;
  color: rgba(105, 105, 105, 100);
  font-size: 16px;
}
.all_styles .style_each .cur_links .list_details {
  line-height: 25px;
  margin-top: 16px;
  height: 75px;
  font-size: 16px;
  font-family: SourceHanSansSC-regular;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
.pagination {
  margin-top: 30px;
  text-align: center;
}
@media screen and (max-width: 1200px) {
	.left_list{
		margin-top: 15rem;
	}
	.w{
		width: 98%;
	}
	.all_styles .style_each .cur_links .cur_topic .check_titls{
		font-size: 2rem;
	}
	.all_styles .style_each .cur_links .all_intros{
		font-size: 1.4rem;
	}
	.all_styles .style_each .cur_links .list_details{
		font-size: 1.6rem;
		line-height: 2.5rem;
		height: auto;
	}
	/deep/.el-pager li{
		max-width: 3rem;
		padding: 0.5rem 1rem;
		height: auto;
		font-size: 1.5rem;
	}
}
</style>